const firebaseConfig = {
  apiKey: "AIzaSyBS0rSYsyAnZLsOC2wM3BEwk4WyXPKiVlw",
  authDomain: "chatbot-demo-53ea1.firebaseapp.com",
  databaseURL: "https://chatbot-demo-53ea1.firebaseio.com",
  projectId: "chatbot-demo-53ea1",
  storageBucket: "chatbot-demo-53ea1.appspot.com",
  messagingSenderId: "839965840345",
  appId: "1:839965840345:web:b9c8b75a066cb555f07fc8",
  measurementId: "G-Y911Q0H69D"
};
export default firebaseConfig